import React from 'react';
import { Boxes, Shield, BarChart3, Database, Bot, LineChart } from 'lucide-react';

const Services = () => {
  const blockchainServices = [
    {
      icon: Boxes,
      title: 'Protocol Engineering',
      description: 'Custom blockchain protocols, consensus mechanisms, and layer-1/layer-2 solutions built for scalability and security.',
      image: 'https://images.pexels.com/photos/546819/pexels-photo-546819.jpeg'
    },
    {
      icon: Shield,
      title: 'Smart Contracts & Audits',
      description: 'Secure smart contract development, comprehensive audits, and vulnerability assessments for DeFi, NFTs, and DAOs.',
      image: 'https://images.pexels.com/photos/9588213/pexels-photo-9588213.jpeg'
    },
    {
      icon: BarChart3,
      title: 'Blockchain Analytics & Chain Analysis',
      description: 'On-chain data indexing, analytics dashboards, and transaction monitoring for insights and compliance.',
      image: 'https://images.unsplash.com/photo-1666875753105-c63a6f3bdc86'
    }
  ];

  const aiServices = [
    {
      icon: Database,
      title: 'AI & Data Engineering',
      description: 'Build robust data pipelines, ETL processes, and data infrastructure to power your AI and analytics systems.',
      image: 'https://images.unsplash.com/photo-1633412802994-5c058f151b66'
    },
    {
      icon: Bot,
      title: 'LLM Models & AI Agents',
      description: 'Custom LLM implementations, AI agents, chatbots, and conversational AI solutions for intelligent automation.',
      image: 'https://images.unsplash.com/photo-1737644467636-6b0053476bb2'
    },
    {
      icon: LineChart,
      title: 'Predictive Analytics & Intelligence',
      description: 'Machine learning models for forecasting, recommendation systems, and business intelligence solutions.',
      image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71'
    }
  ];

  const ServiceCard = ({ icon: Icon, title, description, image }) => (
    <div className="group relative bg-gradient-to-br from-[#1a1f35] to-[#0f1420] rounded-2xl border border-white/10 overflow-hidden hover:border-white/30 transition-all duration-500 hover:transform hover:scale-[1.02]">
      {/* Background Image */}
      <div className="absolute inset-0 opacity-0 group-hover:opacity-20 transition-opacity duration-500">
        <img
          src={image}
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative p-8 space-y-4">
        <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-[#ff6b35] to-[#ff2e63] flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
          <Icon size={28} className="text-white" />
        </div>
        <h3 className="text-2xl font-bold text-white">{title}</h3>
        <p className="text-gray-400 leading-relaxed">{description}</p>
      </div>

      {/* Hover Gradient */}
      <div className="absolute inset-0 bg-gradient-to-t from-[#ff6b35]/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none"></div>
    </div>
  );

  return (
    <section id="services" className="py-24 bg-[#0a0e1a] relative">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4">
            Our Services
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Comprehensive Web3 & AI capabilities. Pick what you need or let us build full-stack products.
          </p>
        </div>

        {/* Blockchain Services */}
        <div className="mb-16">
          <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3">
            <div className="w-1 h-8 bg-gradient-to-b from-[#00d4ff] to-[#0ea5e9] rounded-full"></div>
            Blockchain Services
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {blockchainServices.map((service, index) => (
              <ServiceCard key={index} {...service} />
            ))}
          </div>
        </div>

        {/* AI/ML Services */}
        <div>
          <h3 className="text-2xl font-bold text-white mb-8 flex items-center gap-3">
            <div className="w-1 h-8 bg-gradient-to-b from-[#ff6b35] to-[#ff2e63] rounded-full"></div>
            AI / ML Services
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {aiServices.map((service, index) => (
              <ServiceCard key={index} {...service} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;